import IdentificationCodeTypesScene from '../scenes/IdentificationCodeTypesScene';

const routes = [
  {
    path: '/identificationcodetypes/*',
    menuName: 'identificationcodetypes_plural',
    component: IdentificationCodeTypesScene,
    hasRight: 'identification-code-types/read',
  },
];

export default routes;
